// extracted by css-extract-rspack-plugin
export default {"avatar":"Discussions-module__avatar__vefpj"};